import { CustomerException } from '@/domain/stripe/customer/repository/contract/exception/CustomerException'

export class CustomerEndpointsServerException extends CustomerException {

}
